import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch, formatDateForInput } from "api/Api";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import BASE_URL from "api/Api";
import "assets/theme/admin_form.css";

const EditScheme = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    scheme_title: "",
    scheme_type: "",
    launch_date: "",
    end_date: "",
    benefits: "",
    description: "",
    details: "",
    document_name: "",
    document: null,
  });

  const [existingImage, setExistingImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // 🔥 Fetch Scheme By ID
  const fetchScheme = async () => {
    try {
      const res = await apiFetch(`leader_admin/get_scheme_by_id/${id}`);
      const data = res.data;

      setFormData({
        scheme_title: data.scheme_title || "",
        scheme_type: data.scheme_type || "",
        launch_date: formatDateForInput(data.launch_date),
        end_date: formatDateForInput(data.end_date),
        benefits: data.benefits || "",
        description: data.description || "",
        details: data.details || "",
        document_name: data.document_name || "",
        document: null,
      });

      if (data.document_path) {
        setExistingImage(`${BASE_URL}${data.document_path}`);
      }

    } catch (err) {
      alert(err.message);
    }
  };

  useEffect(() => {
    fetchScheme();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "document") {
      const file = files[0];
      setFormData({ ...formData, document: file });

      if (file && file.type.startsWith("image")) {
        setPreview(URL.createObjectURL(file));
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) {
          data.append(key, formData[key]);
        }
      });

      await apiFetch(`leader_admin/update_scheme/${id}`, {
        method: "PUT",
        body: data,
      });

      alert("Scheme Updated Successfully");
      navigate("/scheme_list");

    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                ✏️ योजना संपादन (Edit Government Scheme)
              </h4>
              <small className="text-white-50">Update government scheme details</small>
            </div>
          </div>

          <Link to="/scheme_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Scheme List
          </Link>
        </div>

        <div className="card border-0 shadow-lg rounded-4">
          <div className="card-body p-4">

            <form onSubmit={handleSubmit}>
              <div className="row g-4">

                {/* Title */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    योजना शीर्षक / Scheme Title *
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="scheme_title"
                    value={formData.scheme_title}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Type */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    योजना प्रकार / Scheme Type *
                  </label>
                  <select
                    className="form-select"
                    name="scheme_type"
                    value={formData.scheme_type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select</option>
                    <option>केंद्र शासन / Central Government</option>
                    <option>राज्य शासन / State Government</option>
                    <option>महानगरपालिका / Municipal</option>
                    <option>स्थानिक संस्था / Local Body</option>
                  </select>
                </div>

                {/* Dates */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    प्रारंभ दिनांक / Launch Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="launch_date"
                    value={formData.launch_date}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    समाप्ती दिनांक / End Date
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    value={formData.end_date}
                    onChange={handleChange}
                  />
                </div>


                {/* Description */}
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    वर्णन / Description
                  </label>
                  <textarea
                    className="form-control"
                    rows="3"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>


                {/* Upload */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    नवीन दस्तऐवज अपलोड करा / Replace File
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="document"
                    onChange={handleChange}
                  />
                </div>

                {/* Existing Image */}
                {existingImage && !preview && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      Current File
                    </label>
                    <div className="border rounded p-2">
                      <a href={existingImage} target="_blank" rel="noreferrer">
                        View Current File
                      </a>
                    </div>
                  </div>
                )}

                {/* New Preview */}
                {preview && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      New Preview
                    </label>
                    <div className="border rounded p-2">
                      <img
                        src={preview}
                        alt="Preview"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                )}

              </div>

              {/* Submit */}
              <div className="text-end mt-4">
                <button
                  type="submit"
                  className="btn btn-success px-5"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update Scheme"}
                </button>
              </div>

            </form>

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default EditScheme;